import _extends from "@babel/runtime/helpers/extends";
import { createContext, useContext, useReducer } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var initialState = {};
var Context = /*#__PURE__*/createContext(initialState);
var reducer = (state, action) => _extends({}, state, action);
export var useShowToolsStore = () => {
  return useContext(Context);
};
var DispatchShowTools = /*#__PURE__*/createContext(() => {});
DispatchShowTools.displayName = 'JVR.DispatchShowTools';
export function useShowTools() {
  return useReducer(reducer, initialState);
}
export function useShowToolsDispatch() {
  return useContext(DispatchShowTools);
}
export var ShowTools = _ref => {
  var {
    initial,
    dispatch,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Context.Provider, {
    value: initial,
    children: /*#__PURE__*/_jsx(DispatchShowTools.Provider, {
      value: dispatch,
      children: children
    })
  });
};
ShowTools.displayName = 'JVR.ShowTools';